export function getTerrainExposureCategoryName(terrainCategory: string) {
  switch (terrainCategory) {
    case 'B_SuburbanAreas':
      return 'B (Suburban Areas)';
    case 'C_ScatteredObstructions':
      return 'C (Scattered Obstructions)';
    case 'D_FlatOpenTerrain':
      return 'D (Flat Open Terrain)';
  }
}
